import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { history } from '_helpers';
import axios from 'axios';
import { numberToWords } from "../_utils/numberToWords";

export { Invoice };

var search_flag = 'today';
var search_datefrom = '';
var search_dateto = '';
var search_status = 'A';
var search_filter = 'D';
var search_modality = '';

function Invoice() {
    const { user: authUser } = useSelector(x => x.auth);
    const { users } = useSelector(x => x.users);
    
    const [invoiceData, setInvoiceData] = useState([]);
    const [invoiceSummary, setInvoiceSummary] = useState([]);
    const [invoiceHeader, setInvoiceHeader] = useState([]);
    
    const [totalPatients, setTotalPatients] = useState(0);
    const [totalReports, setTotalReports] = useState(0);
    const [totalFiles, setTotalFiles] = useState(0);
    const [totalEstimate, setTotalEstimate] = useState(0);

    let PatientHeaderText = 'Patient';
    let displayNone = {
      display: "none"
    };

    useEffect(() => {

        if(authUser?.user_type === 'A' || authUser?.user_type === 'S' || authUser?.user_type === 'D' || authUser?.user_type === 'R')
        {
            if(authUser?.user_type === 'A' || authUser?.user_type === 'S'){
                PatientHeaderText = `Patient/Center`;
            }
        }

        var objpPatientHdr = document.getElementById("pPatientHdr");
        objpPatientHdr.innerHTML=PatientHeaderText;
        
        search_flag = 'today';
        search_datefrom = '';
        search_dateto = '';
        search_status = 'A';
        search_modality = '';

        var objddlfilterType = document.getElementById("ddlfilterType");
        search_filter = objddlfilterType.options[objddlfilterType.selectedIndex].value;

        invoiceList('SEARCH');
      }, []);

      
    // only show when logged in
    if (!authUser) return null;

    const handleSearchChange = (event) => {
        var col_name = event.target.id;
        var col_value = event.target.value; 
          if(col_value===''){
            col_value = '';
          }
          else{
            var value_split = col_value.split('-');
              col_value = value_split[2] + '-' + value_split[1] + '-' + value_split[0];
          }
        if(col_name === 'txtfromdate'){ search_datefrom = col_value; }
        if(col_name === 'txttodate'){ search_dateto = col_value; }
    };
    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
    function invoiceList(action_tag) {
        if (!authUser) return null;
  
        const user_key = authUser?.user_key;
        const center_key = authUser?.center_key;

        const request_id = randomNumberInRange(1000000, 9000000);
        const token = JSON.parse(localStorage.getItem('user')).token;

        let url = `${process.env.REACT_APP_API_URL}/invoice`;
        /*if(authUser?.user_type === 'A' && (search_flag === 'thismonth' || search_flag === 'prevmonth'))
        {
            url = `${process.env.REACT_APP_API_URL_EC2}/invoice`;
        }*/

        const config = {
          headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'user_key': user_key.toString(),
            'center_key': center_key.toString(),
            'action_tag': action_tag,
            'search_flag': search_flag,
            'search_datefrom': search_datefrom,
            'search_dateto': search_dateto,
            'search_status': search_status,
            'search_filter': search_filter,
            'search_modality': search_modality,
            'request_id': request_id.toString()
          },
        };
    
        try {
          
            ProcessStatus(true, false, '');

          axios.get(url, config).then((response) => {
            //console.log(response.data);
            
            //alert(JSON.stringify(response.data));

            setTotalPatients(0);
            setTotalReports(0);
            setTotalFiles(0);
            setTotalEstimate(0);

            var record_exist = false;
            let updatedValue = {};
            if(response.data.invoice_details.length===0){
              setInvoiceData([]);
              setInvoiceSummary([]);
              setInvoiceHeader([]);
            }
            else{
              record_exist = true;
              updatedValue = response.data; 

              if(updatedValue.invoice_header != null){
                if(updatedValue.invoice_header.length > 0){
                    setTotalPatients(updatedValue.invoice_header[0].total_patients);
                    setTotalReports(updatedValue.invoice_header[0].total_reports);
                    setTotalFiles(updatedValue.invoice_header[0].total_files);
                    setTotalEstimate(updatedValue.invoice_header[0].total_estimate);
                }
              }

              setInvoiceData(updatedValue.invoice_details);
              setInvoiceSummary(updatedValue.invoice_summary);
              setInvoiceHeader(updatedValue.invoice_header);
           }

           ProcessStatus(false, record_exist, '');
          });
        } catch (err) {
            ProcessStatus(false, false, '');
          //debugger;
          //alert('error');
            //alert(err.code);
          if (err.code === '404') {
            //setError('Object does not exist.')
            return
          }
        }
    
      }
  
      function ProcessStatus(buttonDisabled, record_exist, filter_col_value) {
        if(buttonDisabled){
          document.getElementById("divLoading").style.display = '';
          document.getElementById("divLoading").innerHTML = 'Processing...';
        }
        else
        {
          document.getElementById("divLoading").innerHTML = '';
          document.getElementById("divLoading").style.display = 'none';
  
          if(record_exist)
           {
              document.getElementById("divStatus").innerHTML = '';
              document.getElementById("divStatus").style.display = 'none';
           }
           else{
              document.getElementById("divStatus").style.display = '';
              if(filter_col_value===''){
                document.getElementById("divStatus").innerHTML = 'No Record Found!';
              }
              else{
                document.getElementById("divStatus").innerHTML = 'Search value '+filter_col_value+' does not found any record.';
              }
           }
        }
      }
  
    const applySearch = (event, param) => {
        event.preventDefault();

        var objddlSelection = document.getElementById("ddlSelection");
        search_flag = objddlSelection.options[objddlSelection.selectedIndex].value;

        search_datefrom = document.getElementById("txtfromdate").value;
        search_dateto = document.getElementById("txttodate").value;

        var objddlfilterStatus = document.getElementById("ddlfilterStatus");
        search_status = objddlfilterStatus.options[objddlfilterStatus.selectedIndex].value;

        var objddlfilterType = document.getElementById("ddlfilterType");
        search_filter = objddlfilterType.options[objddlfilterType.selectedIndex].value;

        var objddlfilterModality = document.getElementById("ddlfilterModality");
        search_modality = objddlfilterModality.options[objddlfilterModality.selectedIndex].value;

        if(search_flag === 'datewise')
        {
            if(search_datefrom===''){
                alert('Enter from date.'); return false;
            }
            if(search_dateto===''){
                alert('Enter to date.'); return false;
            }
        }

        invoiceList('SEARCH');
    }
    function sortClick(event, col_name)
    {
          ;
    }
    function printInvoiceClick(){
        printReport(true);
    }
    function printClick(_printInvoice)
    {
        printReport(false);
    }
    function printReport(_printInvoice)
    {
        if(invoiceData.length === 0){
            alert('No record found.');
            return false;
        }

        if(invoiceHeader.length === 0){
            alert('No record found(Header).');
            return false;
        }
        else{
            if(_printInvoice){
                if(invoiceHeader[0].invoice_number === null){
                    _printInvoice = false;
                    alert('Invoice is not yet generated, printing inquiry.');
                }
                else{
                    if(authUser?.user_type === 'A' || authUser?.user_type === 'S'){
                        if(window.confirm('Do you want to print individual invoice of each center?')!== true) {
                            _printInvoice = false;
                        }
                    }
                }
            }
        }

        var _inquery = true;
        if(_printInvoice){
            _inquery = false; //skp for generate invoice
        }
        
        if(_inquery){
            printInvoice(_inquery, 0);
        }
        else{
            for(var index_hdr=0;index_hdr<invoiceHeader.length;index_hdr++)
            {
                printInvoice(_inquery, index_hdr);
                if(index_hdr>1){
                    ;
                //break; //skp
                }
            }
        }
       
    }

    function printInvoice(_inquery, index_hdr)
    {
        const template = getReportContent(_inquery, index_hdr);
        var WinPrint = window.open('', 'invoicePrint'+index_hdr.toString(), 'width=850,height=600'); 
        WinPrint.document.write(template);
        WinPrint.document.close();
        WinPrint.focus();

        setTimeout(function() {
            WinPrint.print();
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                    setTimeout(function() {
                    WinPrint.close();
                    }, 30000);
                    }
                else{
                    WinPrint.close();
                }
        }, 2000); 
     
    }

    const getReportContent = (_inquery, index_hdr) =>
    {
      var _marginTop = '30px';
      var _marginRight = '20px';
      var _marginBottom = '30px';
      var _marginLeft = '20px';

        //_inquery = false;
      var title = 'Invoice Inquiry'; 
      if(authUser?.user_type === 'U') {
        title += `-` + invoiceHeader[index_hdr].center_name + `-` + invoiceHeader[index_hdr].center_id;
      }

      var _invoice_number = invoiceHeader[index_hdr].invoice_number;
      if(_invoice_number === null){
        _invoice_number = '';
      }
      else{
        _invoice_number = _invoice_number.replace(/\//g, '_')+'-'; 
      }

      var _invoice_for_month = invoiceHeader[index_hdr].invoice_for_month;
      if(_invoice_for_month === null){
        _invoice_for_month = '';
      }
      else{
        _invoice_for_month = _invoice_for_month.replace(/ /g, '').replace('-', '')+'-'; 
      }

      var _invoice_amount = invoiceHeader[index_hdr].invoice_amount;
      if(_invoice_amount === null){
        _invoice_amount = 0;
      }
      var _tds_amount = invoiceHeader[index_hdr].tds_amount;
      if(_tds_amount === null){
        _tds_amount = 0;
      }
      var _tds_perc = invoiceHeader[index_hdr].tds_perc;
      if(_tds_perc === null){
        _tds_perc = 0;
      }
      var _total_estimate = invoiceHeader[index_hdr].total_estimate;
      if(_total_estimate === null){
        _total_estimate = 0;
      }

      if (_inquery === false){
        title = _invoice_for_month + _invoice_number + invoiceHeader[index_hdr].center_id + '-' + invoiceHeader[index_hdr].center_name.replace(/ & /g, '_').replace(/ /g, '_');
      }
      
      let displayRate = true;
      if(authUser?.user_type === 'U' 
        || (authUser?.user_type === 'A' && authUser?.user_key !== 1)) {
            displayRate = false;
      }
      var _invocie_date_summary = '';
      var template_head = `<!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>`+title+`</title>
          <link href="css/report_template_print.css?v=${process.env.REACT_APP_VERSION}" rel="stylesheet" />

          <!-- Google Font -->
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&display=swap" rel="stylesheet">
      </head>
      <body>
        <div class="container" style="margin-top: `+ _marginTop + `;margin-right: `+ _marginRight + `;margin-bottom: `+ _marginBottom + `;margin-left: `+ _marginLeft  + `;">
        
    `;

    var _invoice_hdr_caption = 'MONTHLY BILL SUMMARY';
    if (_inquery){
        _invoice_hdr_caption = 'Invoice Inquiry';
    }
    
    var _rate_caption = 'Total(Rs.)';
    if (_inquery){
        _rate_caption = 'Estimate';
    }
    
    var _billedto_caption = 'Billed To';
    var _centerid_caption = 'Center Id';
    var _pagebreak_css=`style="page-break-after: always;"`;
    if(authUser?.user_type === 'D' || authUser?.user_type === 'R' || authUser?.user_type === 'G'){
        _billedto_caption = 'Pay To';
        _centerid_caption = 'User Id';
        _pagebreak_css=``;
    }

    var template_hdr_row1 ='';
    if (_inquery){
        template_hdr_row1 = `<tr>
                            <td colspan="8">
                            <div class="invoice-header">
                                <div class="invoice-header-left">
                                    <h4>`+_invoice_hdr_caption+`</h4>
                                </div>
                            </div>
                            </td>
                        </tr>`;
    }
    else {
        template_hdr_row1 = `<tr>
                                <td colspan="10">

                                <div class="invoice-header">
                                    <div class="invoice-header-left">
                                        <img src="img/mytsoft-logo.png"/>
                                        <h4>MYT<span>Soft</span></h4>
                                        <p>
                                        NABAJIBAN, NEAR DUMDUM AIRPORT <br/>
                                        KOLKATA-700158, INDIA <br/>
                                        PHONE: +91 98369 03886 <br/>
                                        </p>
                                    </div>
                                    <div class="invoice-header-right">
                                        <h2>`+_invoice_hdr_caption+`</h2>
                                        <p>Invoice Number: `+invoiceHeader[index_hdr].invoice_number+`<br/>
                                            Invoice Date: `+new Date(invoiceHeader[index_hdr].invoice_date).toLocaleDateString("en-GB")+` <br/>
                                            Due Date: `+new Date(invoiceHeader[index_hdr].due_date).toLocaleDateString("en-GB")+` <br/>
                                            Billing Period: `+invoiceHeader[index_hdr].invoice_for_month+` <br/>
                                            `+_centerid_caption+`: `+invoiceHeader[index_hdr].center_id+` <br/>
                                        </p>
                                    </div>
                                </div>
                                <div class="invoice-recipient">
                                    <h4 class="primary-bg">`+_billedto_caption+` </h4>
                                    <h3>`+invoiceHeader[index_hdr].center_name+`</h3>
                                    <p>`+invoiceHeader[index_hdr].address+`<br>
                                    `+invoiceHeader[index_hdr].state+ ` ` + invoiceHeader[index_hdr].zipcode + `<br>
                                    </p>
                                </div>

                                </td>
                            </tr>
                            <tr><td  style="background-color:white; height:2px;" colspan="10"></td></tr>`;
        }
    
        var dtls_hdr_row = `<tr><td colspan="7" class="text-center"><b>Study Service Details</b></td></tr>`
        dtls_hdr_row += `<tr>
                                <th style="width:20px;" class="text-center">Srl#</th>
                                <th style="width:60px;" >Date</th>
                                <th>Patient</th>`;
        if (_inquery){
            dtls_hdr_row += `<th style="width:50px;" >Reports</th>`;
        }
        dtls_hdr_row += `<th style="width:300px;">Study</th>
                                <th style="width:25px;" >Files</th>`;
        if(displayRate) {
           dtls_hdr_row +=`<th style="width:45px;">Unit Price</th>
                                <th style="width:50px;" class="text-right">`+_rate_caption+`</th>`;
        }
        dtls_hdr_row +=`</tr>`;

    var patient_key_old = 0; var srl_no = 0;
    var template_body = `<tbody class="report-body">`;
    
    let filteredData = invoiceData;
    if (_inquery === false){
        filteredData = invoiceData.filter((item) => {
            const matchesCenterKey = item.center_key === invoiceHeader[index_hdr].center_key;
            const matchesInvoiceKey = item.invoice_key === invoiceHeader[index_hdr].invoice_key;

            return matchesCenterKey && matchesInvoiceKey;
        });
    }

    let filteredTotAmount = 0;
    for(var index=0;index<filteredData.length;index++){
        var _report_count = filteredData[index].report_count;
        _report_count = 1;

        filteredTotAmount += parseFloat(filteredData[index].total_amount);
        
        var _patient_dtls = filteredData[index].patient_id +` - `+ filteredData[index].patient_name;
        
        if(_invocie_date_summary===''){
            const options = { month: 'short', year: 'numeric' };
            _invocie_date_summary = new Date(filteredData[index].regn_on).toLocaleDateString('en-US', options); 
        }

        if(filteredData[index].patient_age > 0 || filteredData[index].patient_sex !== ''){
            _patient_dtls += ` `+ filteredData[index].patient_age +`/`+ filteredData[index].patient_sex;
        }

        if(patient_key_old === filteredData[index].patient_key && 1===2)
        {
            template_body += `
            <tr>
                <td class="text-center"></td>
                <td></td>
                <td></td>`;

            if (_inquery){
                template_body += `<td></td>`;
            }
        }
        else
        {
            srl_no++;
            template_body += `
            <tr>
                <td class="text-center">`+srl_no+`</td>
                <td>`+new Date(filteredData[index].regn_on).toLocaleDateString("en-GB")+`</td>
                <td>`+_patient_dtls+`</td>`;

            if (_inquery){
                template_body += `<td>`+_report_count+`</td>`;
            }
        }

        template_body += 
        `   <td>`+filteredData[index].service+`</td>
            <td>`+filteredData[index].image_group_count+`</td>`;

        if(displayRate) {
            template_body +=
            `<td>`+filteredData[index].unit_price +`</td> 
            <td class="text-right">`+filteredData[index].total_amount+`</td>`;
        }
        template_body += `</tr>`;

        patient_key_old = filteredData[index].patient_key;
    }

    // footer body
    template_body += `<tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>`;
    if (_inquery){
        template_body += `<th></th>`;
    }
    template_body += `<th></th>
                            <th></th>`;
    if(displayRate) {
        template_body +=`<th></th>
                            <th class="text-right">`+filteredTotAmount.toString()+`</th>`;
    }
    template_body +=`</tr>`;

    template_body +=`</tbody>`;

    // ********** start summary
    var summary_body = '';
    if (_inquery === false){
        var summary_hdr_row = `<tr>
                            <th style="width:50px;">Srl#</th>
                            <th style="width:100px;" >Date</th>
                            <th colspan="4">Summary Service</th>`;
        if(displayRate) {
            summary_hdr_row +=`<th style="width:60px;">Unit Price</th>
                                <th style="width:80px;" class="text-right">`+_rate_caption+`</th>`;
        }
        summary_hdr_row +=`</tr>`;

        srl_no = 0;
        summary_body = `<tbody class="report-body">`;
        
        const filteredSummary = invoiceSummary.filter((item) => {
            const matchesCenterKey = item.center_key === invoiceHeader[index_hdr].center_key;
            const matchesInvoiceKey = item.invoice_key === invoiceHeader[index_hdr].invoice_key;

            return matchesCenterKey && matchesInvoiceKey;
        });

        let filteredSummaryTotAmount = 0;
        let _summary_service='';
        for(var indexSummary=0;indexSummary<filteredSummary.length;indexSummary++){
            filteredSummaryTotAmount += parseFloat(filteredSummary[indexSummary].rate_total);
            srl_no++;
            
            _summary_service='';
            if(authUser?.user_type === 'G'){
                _summary_service+=filteredSummary[indexSummary].view_flag; 
                _summary_service+= ': '; 
                //_summary_service+='<br/>';
            }

            _summary_service+=filteredSummary[indexSummary].modality;
            if(filteredSummary[indexSummary].modality === 'CR' || filteredSummary[indexSummary].modality === 'DX')
            {
                _summary_service+=' - X-RAY';
                if(filteredSummary[indexSummary].rate_name === '[ANY OTHER SPECIAL]'){
                    ;//_summary_service+=' OTHERS';
                }
                else if(filteredSummary[indexSummary].rate_name === '[ANY OTHER NORMAL]'){
                    ;//_summary_service+=' OTHERS';
                }
                else{
                    _summary_service+=' ' + filteredSummary[indexSummary].rate_name;
                }
                
                if(filteredSummary[indexSummary].rate_type === 'S'){
                    _summary_service+='(SPECIAL)';
                }
                else{
                    if(filteredSummary[indexSummary].view_flag === 'S'){
                        _summary_service+='(SINGLE VIEW)';
                    }
                    else if(filteredSummary[indexSummary].view_flag === 'D'){
                        _summary_service+='(DOUBLE VIEW)';
                    }
                }
            }
            else if(filteredSummary[indexSummary].modality === 'ECG'){
                _summary_service+=' - ECG';
            }
            else if(filteredSummary[indexSummary].modality === 'CT'){
                if(filteredSummary[indexSummary].rate_name === '[ANY OTHER CT]'){
                    ;//_summary_service+=' OTHERS';
                }
                else {
                    _summary_service+=' ' + filteredSummary[indexSummary].rate_name;
                }
            }
            else{
                ;
            }

            summary_body += `
            <tr>
                <td class="text-center">`+srl_no+`</td>
                <td>`+_invocie_date_summary+`</td>
                <td colspan="4">`+_summary_service+`</td>`;

            if(displayRate) {
                summary_body +=
                `<td>`+filteredSummary[indexSummary].service_rate + ` x ` + filteredSummary[indexSummary].report_total +`</td> 
                <td class="text-right">`+filteredSummary[indexSummary].rate_total+`</td>`;
            }
            summary_body += `</tr>`;
        }
        
        var summary_footer_row1 = '';

        // TDS amount
        if(_tds_amount>0 && displayRate){
            if(filteredSummaryTotAmount !== invoiceHeader[index_hdr].invoice_amount)
            {
                alert('Invoice amount mismatch, total: ' + filteredSummaryTotAmount + ', invoice:' + invoiceHeader[index_hdr].invoice_amount);
            }
            summary_footer_row1 += `<tr style="height:25px;">
                                    <td colspan="8" class="text-right">
                                    <hr style="border: none; height: 1px; background-color: black;" />
                                    </td></tr>`;

            summary_footer_row1 += `<tr>
                                    <td colspan="6" class="text-right"><b>Total</b> </td>
                                    <td></td>
                                    <td class="text-right"><b>`+filteredSummaryTotAmount.toString()+`</b></td></tr>`;
            
            summary_footer_row1 += `<tr>
                                    <td colspan="6" class="text-right"><b>TDS `+_tds_perc.toString()+`%</b> </td>
                                    <td></td>
                                    <td class="text-right"><b>`+_tds_amount.toString()+`</b></td></tr>`;

            summary_footer_row1 += `<tr>
                                    <th colspan="6" class="text-right">Net Amount</th>
                                    <th></th>
                                    <th class="text-right">`+(filteredSummaryTotAmount - _tds_amount).toString()+`</td></tr>`;

        }
        else{
            summary_footer_row1 = `<tr>
                                    <th colspan="6">Total</th>`;
            if(displayRate) {
                summary_footer_row1 +=`<th></th>
                                    <th class="text-right">`+filteredSummaryTotAmount.toString()+`</th>`;
            }
            summary_footer_row1 +=`</tr>`;
        }

        //amount in word 
        if(displayRate){
            summary_footer_row1 += `<tr>
                                <td colspan="8"><br/>
                                Amount in words: <b>`+numberToWords(filteredSummaryTotAmount - _tds_amount)+`</b>
                                </td></tr>`;
        }

        var payment_dtls_rows ='';
        if(authUser?.user_type === 'D' || authUser?.user_type === 'R' || authUser?.user_type === 'G'){
            payment_dtls_rows = `<tr style="height:20px">
                                        <td colspan="6">&nbsp;</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;
        }
        else{
            //payment details
            payment_dtls_rows = `<tr>
                                        <td colspan="6"><br/><b>Payment Information:</b></th>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 1
            payment_dtls_rows += `<tr>
                                        <td colspan="2">Account Name</th>
                                        <td colspan="4">: MYTSOFT</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 2
            payment_dtls_rows += `<tr>
                                        <td colspan="2">Account Number</th>
                                        <td colspan="4">: 50200083556081</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 3
            payment_dtls_rows += `<tr>
                                        <td colspan="2">Account Type</th>
                                        <td colspan="4">: Current Account</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 3
            payment_dtls_rows += `<tr>
                                        <td colspan="2">Bank Name</th>
                                        <td colspan="4">: HDFC, BIRATI BRANCH</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 4
            payment_dtls_rows += `<tr>
                                        <td colspan="2">IFSC Code</th>
                                        <td colspan="4">: HDFC0002421</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 5
            payment_dtls_rows += `<tr>
                                        <td colspan="2">GPAY Number</th>
                                        <td colspan="4">: 9088150220</td>`;
            if(displayRate) {
                payment_dtls_rows +=`<td></td>
                                    <td></td>`;
            }
            payment_dtls_rows +=`</tr>`;

            //row 6
            payment_dtls_rows += `<tr><td colspan="8" class="text-center">If you have any questions about this invoice, please contact</td></tr>`;
            payment_dtls_rows += `<tr><td colspan="8" class="text-center">Sumanta Das, +91 98369 03886, contact@mytsofts.com</td></tr>`;
        }

        summary_body += `<tfoot>`+summary_footer_row1  + payment_dtls_rows+ `</tfoot>`;

        summary_body += `</tbody>`;
        // ********** end summary
    }

    var template_footer = `
    <footer class="divFooter">
        <div class="row">
            <div class="col-12">
                <div class="footsign">
                    For further queries, please call us / e-mail us at contact@mytsofts.com
                </div>
            </div>
        </div>
    </footer>
    </div>
    </body>

    </html>`;
    
    let template = template_head;
    if (_inquery){
      dtls_hdr_row = template_hdr_row1 + dtls_hdr_row;
    }
    else{
        template += `<table id="reportSummary" `+_pagebreak_css+`><thead class="report-header">`+ template_hdr_row1 + summary_hdr_row +
                    summary_body+
                `</thead></table>`;  
    }

    template += `<table id="report"><thead class="report-header">`+  dtls_hdr_row +
                    template_body+
                `</thead></table>`+
                template_footer;

      return template;
    }

    function quickSearchClick(event) {
      var objctrl = document.getElementById("panelsStayOpen-collapseOne");
      if(objctrl.style.display === 'none'){
      objctrl.style.display = "inline";
      }
      else{
        objctrl.style.display = "none";
      }
  }
    function showFilterDiv(event) {
      var objddlSelection = document.getElementById("ddlSelection");
      const filterSelection = objddlSelection.options[objddlSelection.selectedIndex].value;      
      document.getElementById('divDateRangeFilter').style.display = filterSelection === 'datewise' ? 'block' : 'none';
  }

    const closeClick = (event) => {
        history.navigate('/home');
    };
    
    return (
        <>
            <main>
                <div className="container-fluid px-4">

                    <div className="row">
                        <div className="col-12 col-lg-7 col-md-10 col-sm-10 mt-2">
                            <h5 className="text-blue font-roboto font-weight700">Invoice Inquiry</h5>
                        </div>
                         
                        <div className="col-3 col-lg-2 col-md-1 col-sm-1 mt-2 mb-1">
                            {(authUser?.user_key === 154 || 1===2 ? 
                                  <button type="button" className="btn btn-secondary btn-sm btn-block text-light bi bi-save2" id="btnPrintInvoice" onClick={printInvoiceClick}> PRINT INVOICE</button>
                                : <span></span>
                              )}
                        </div>
                        <div className="col-3 col-lg-2 col-md-1 col-sm-1 mt-2 mb-1">
                            <button type="button" className="btn btn-secondary btn-sm btn-block text-light bi bi-save2" id="btnPrintInquiry" onClick={printClick}> PRINT INQUIRY</button>
                        </div>
                        <div className="col-6 col-lg-1 col-md-1 col-sm-1 mt-2 mb-1">
                            <button type="button" className="btn btn-dark btn-sm btn-block text-light bi bi-x-circle" id="btnClose" onClick={closeClick}> CLOSE</button>
                        </div>
                    </div>

                    <hr className="mt-0" />

                    {/*<!-- Accordion Reprot Generate -->*/}
                    <div className="row">
                        <div className="col-12 col-lg-12 col-md-12 col-sm-12 mt-2">
                            <div className="accordion" id="accordionPanelsStayOpenExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="panelsStayOpen-headingOne">
                                        <button className="accordion-button" type="button" aria-expanded="true" onClick={event => quickSearchClick(event)}>
                                            <i className="bi bi-file-earmark-medical iconcolr-w"></i>&nbsp; Quick Selection Report
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseOne" className="accordion-collapse show"
                                        aria-labelledby="panelsStayOpen-headingOne">
                                        <div className="accordion-body">
                                            <div className="row">
                                                <div className="col-4 col-lg-2 col-md-2 col-sm-12 mt-1">
                                                    <select className="form-select form-select-sm" id="ddlSelection" name="ddlSelection"
                                                      onChange={event => showFilterDiv(event) }>
                                                        <option value="today">Today</option>
                                                        <option value="yesterday">Yesterday</option>
                                                        <option value="last7days">Last 7 Days</option>
                                                        <option value="thismonth">This Month</option>
                                                        <option value="prevmonth">Previous Month</option>
                                                        <option value="datewise">Date Wise</option>
                                                    </select>
                                                </div>
                                                <div className="col-4 col-lg-4 col-md-4 col-sm-12 mt-1" id="divDateRangeFilter" style={displayNone}>
                                                    <div className="row">
                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-12 ps-2 pe-2">
                                                            <div className="input-group input-group-sm">
                                                                <div className="input-group-prepend"><span id="basic-addon1" className="input-group-text">
                                                                  <small>From Date</small></span>
                                                                </div> 
                                                                <input type="date" placeholder="From Date" id="txtfromdate" name="txtfromdate" required="required" className="form-control form-control-sm tele-table-invoicearea" onChange={handleSearchChange} />
                                                            </div>
                                                        </div>
                                                        <div className="col-6 col-lg-6 col-md-6 col-sm-12 ps-2 pe-2">
                                                            <div className="input-group input-group-sm">
                                                                <div className="input-group-prepend"><span id="basic-addon1" className="input-group-text">
                                                                  <small>To Date</small></span>
                                                                </div> 
                                                                <input type="date" placeholder="To Date" id="txttodate" name="txttodate" required="required" className="form-control form-control-sm tele-table-invoicearea" onChange={handleSearchChange} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4 col-select col-md-2 col-sm-12 mt-1" id="divfilterType">
                                                    <select className="form-select form-select-sm" id="ddlfilterType" name="ddlfilterType">
                                                        <option value="S">Summary</option>
                                                        <option value="D">Detail</option>
                                                    </select>
                                                </div>
                                                <div className="col-4 col-select col-md-2 col-sm-12 mt-1">
                                                    <select className="form-select form-select-sm" id="ddlfilterModality" name="ddlfilterModality">
                                                        <option value="">All Modality</option>
                                                        <option value="DX">X-Ray</option>
                                                        <option value="MG">MG</option>
                                                        <option value="CT">CT</option>
                                                        <option value="ECG">ECG</option>
                                                    </select>
                                                </div>
                                                <div className="col-4 col-select col-md-2 col-sm-12 mt-1">
                                                    <select className="form-select form-select-sm" id="ddlfilterStatus" name="ddlfilterStatus">
                                                        <option value="A">All Status</option>
                                                        <option value="P">Pending</option>
                                                        <option value="S">Signed Off</option>
                                                        <option value="U">Urgent</option>
                                                        <option value="F">Printed</option>
                                                    </select>
                                                </div>
                                                <div className="col-6 col-lg-2 col-md-2 col-sm-12 mt-1">
                                                    <button type="button" className="btn btn-dark btn-sm btn-block text-light bi bi-play-fill" id="btnApply" onClick={event => applySearch(event, 'Search')}> APPLY</button>
                                                </div>
                                                <div className="col-6 col-lg-2 col-md-2 col-sm-12 mt-1">
                                                    <div className="nav-item" id="divLoading"> processing...</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*<!-- End of Accordion Reprot Generate -->*/}


                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <div className="tab-content" id="tblInvoiceDtls">
                                <div className="tab-pane fade show active mt-2" id="all-tab-pane" role="tabpanel"
                                    aria-labelledby="all-tab" tabindex="0">
                                    <div className="card">
                                        <div className="card-header bg-gradient-1 text-light">
                                            {/*<!-- Table Heading -->*/}
                                            <div className="row">
                                                <div className="col-4 col-sm-1 col-md-1">
                                                    <p className="tele-table-heading">Date </p>
                                                </div>
                                                <div className="col-4 col-sm-2 col-md-3">
                                                    <p className="tele-table-heading" id="pPatientHdr">Patient </p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-heading">Status </p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-heading">Reports </p>
                                                </div>
                                                <div className="col-4 col-sm-2 col-md-3 d-none d-sm-block">
                                                    <p className="tele-table-heading">Study </p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-heading">Files </p>
                                                </div>
                                                {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                    :   
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                            <p className="tele-table-heading">Unit</p>
                                                        </div>
                                                )}
                                                {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                    :   
                                                        <div className="col-4 col-sm-2 col-md-1 text-right">
                                                            <p className="tele-table-heading">Estimate </p>
                                                        </div>
                                                )}
                                                
                                            </div>
                                        </div>
                                        <div className="card-body tele-table-padding invoice-studylist-area">
                                            {/*<!-- tele-table-rowbg1 -->*/}

                                            <div className="row studylist" id="divStatus">
                                            </div>

                                            {Object.keys(invoiceData).map((data, i) => (
                                                <div key={i} className="row studylist">
                                                    <div className="col-4 col-sm-1 col-md-1">
                                                        {(invoiceData[i].file_seq_no === 1 ?
                                                            <p className="tele-table-dash-text">{invoiceData[i].regn_date}</p>
                                                            : <span></span>
                                                        )}
                                                    </div>
                                                    <div className="col-4 col-sm-2 col-md-3">
                                                        {(invoiceData[i].file_seq_no === 1 ?
                                                            <p className="tele-table-dash-text">{invoiceData[i].patient_id} - {invoiceData[i].patient_name} {invoiceData[i].patient_age}/{invoiceData[i].patient_sex}</p>
                                                            : <span></span>
                                                        )}
                                                    </div>

                                                    <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                        {(invoiceData[i].file_seq_no === 1 ?
                                                            <p className="tele-table-dash-text">{invoiceData[i].report_status_desc}</p>
                                                            : <span></span>
                                                        )}
                                                    </div>
                                                    <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                        {(invoiceData[i].file_seq_no === 1 ?
                                                            <p className="tele-table-dash-text">{invoiceData[i].report_count}</p>
                                                            : <span></span>
                                                        )}
                                                    </div>
                                                    <div className="col-4 col-sm-2 col-md-3 d-none d-sm-block">
                                                        <p className="tele-table-dash-text">{invoiceData[i].service}</p>
                                                    </div>
                                                    <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                        <p className="tele-table-dash-text">{invoiceData[i].image_group_count}</p>
                                                    </div>
                                                    {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                            <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                        :   
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block"> <p className="tele-table-dash-text">{invoiceData[i].unit_price}</p></div>
                                                    )}
                                                    
                                                    {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                            <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                        :   
                                                        <div className="col-4 col-sm-2 col-md-1 text-right"> <p className="tele-table-dash-text">{invoiceData[i].total_amount}</p></div>
                                                    )}
                                                    
                                                </div>
                                            ))}

                                        </div>

                                        <div className="card-footer bg-gradient-1 text-light">
                                            {/*<!-- Table Footer -->*/}
                                            <div className="row">
                                                <div className="col-4 col-sm-1 col-md-1">
                                                    <p className="tele-table-dash-heading">Total</p>
                                                </div>
                                                <div className="col-4 col-sm-2 col-md-3">
                                                    <p className="tele-table-dash-heading">{totalPatients}</p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-dash-heading"> </p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-dash-heading">{totalReports} </p>
                                                </div>
                                                <div className="col-4 col-sm-2 col-md-3 d-none d-sm-block">
                                                    <p className="tele-table-dash-heading"> </p>
                                                </div>
                                                <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                    <p className="tele-table-dash-heading">{totalFiles} </p>
                                                </div>
                                                {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                    :   
                                                    <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block">
                                                        <p className="tele-table-dash-heading"></p>
                                                    </div>
                                                )}
                                                
                                                {(authUser?.user_type === 'U' || (authUser?.user_type === 'A' && authUser?.user_key !== 1) ? 
                                                        <div className="col-4 col-sm-1 col-md-1 d-none d-sm-block" style={displayNone}></div>
                                                    :   
                                                    <div className="col-4 col-sm-2 col-md-1 text-right">
                                                        <p className="tele-table-dash-heading">{totalEstimate} </p>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </main>

            {users.loading && <div className="spinner-border spinner-border-sm"></div>}
            {users.error && <div className="text-danger">Error loading users: {users.error.message}</div>}

        </>
    );
}
